import {FC} from 'react';
import {Tooltip} from '@mui/material';
import capitalize from 'lodash/capitalize';

import {ColorLabel} from '@shared/components';
import {getLabelColors} from '@shared/constants';
import {OrderLabel} from '../types';

interface Props {
  label: OrderLabel;
  /** Show only the first letter and move the full label to a tooltip */
  isShortened?: boolean;
}

export const OrderLabelBadge: FC<Props> = ({label, isShortened = false}) => {
  const {bgColor, textColor} = getLabelColors(label);
  const fullText = capitalize(label);

  const badge = (
    <ColorLabel
      display="inline-flex"
      justifyContent="center"
      minWidth={isShortened ? 24 : undefined}
      bgcolor={bgColor}
      color={textColor}
    >
      {isShortened ? label.charAt(0).toUpperCase() : fullText}
    </ColorLabel>
  );

  if (!isShortened) {
    return badge;
  }

  return <Tooltip title={fullText}>{badge}</Tooltip>;
};
